import React from 'react';
import { Sidebar } from './Sidebar';
import { FloatingHeader } from './FloatingHeader';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);       // mobile drawer
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(() => {
    try { return localStorage.getItem('sidebar_collapsed') === 'true'; } catch { return false; }
  });

  React.useEffect(() => {
    try { localStorage.setItem('sidebar_collapsed', String(sidebarCollapsed)); } catch {}
  }, [sidebarCollapsed]);

  return (
    <div className="flex min-h-screen bg-background">
      {/* Sidebar */}
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed((v) => !v)}
      />

      {/* Main area — margin adjusts with sidebar state */}
      <div
        className={[
          'flex flex-col flex-1 min-h-screen transition-[margin] duration-300 ease-in-out',
          sidebarCollapsed ? 'lg:ml-[4.5rem]' : 'lg:ml-64',
        ].join(' ')}
      >
        {/* Floating header */}
        <FloatingHeader
          onMenuClick={() => setSidebarOpen(true)}
          sidebarCollapsed={sidebarCollapsed}
        />

        {/* Page content */}
        <main className="flex-1 bg-background pt-24 px-4 pb-4 md:px-6 md:pb-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;